import React from 'react'
import PropTypes from 'prop-types'
import muiThemeable from 'material-ui/styles/muiThemeable'
import Toolbar from 'material-ui/Toolbar'

const CustomToolbar = muiThemeable()(
  ({
    primary,
    children,
    muiTheme: {
      palette: {
        primary1Color,
      }
    },
  }) => {
    return (
      <Toolbar style={primary ? { backgroundColor: primary1Color } : {}}>
        {children}
      </Toolbar>
    )
  }
)

CustomToolbar.propTypes = {
  primary: PropTypes.bool,
}
CustomToolbar.defaultProps = {
  primary: false,
}

export default CustomToolbar



// WEBPACK FOOTER //
// ./src/components/bars/CustomToolbar.js